import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { BookingLinkEmbed } from '@/types/bookingConfig';

/** Server-built copy-paste embed snippet for a booking link's widget. */
export function useBookingLinkEmbed(id: string | null) {
  return useApiQuery<BookingLinkEmbed>({
    queryKey: [...settingsKeys.bookingLinks(), id ?? 'none', 'embed'],
    queryFn: () =>
      apiGet<BookingLinkEmbed>(operationsClient, settingsEndpoints.bookingLinkEmbed(id!)),
    enabled: Boolean(id),
    showErrorToast: false,
  });
}
